import Swiper from "swiper";
import { Pagination, Navigation } from 'swiper/modules';

function sliderHero() {
  new Swiper('.hero__slider-main .swiper', {
    modules: [Pagination, Navigation],
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
  });
  new Swiper('.hero__slider-small .swiper', {
    modules: [Pagination, Navigation],
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
  });
}
sliderHero();